import { createContext } from 'react';
import type { SignupContextType } from './types';

export const SignupContext = createContext<SignupContextType | undefined>(undefined);
